import { render } from "./SubmitPopup.vue?vue&type=template&id=dec9abe0&scoped=true"
import script from "./SubmitPopup.vue?vue&type=script&lang=js"
export * from "./SubmitPopup.vue?vue&type=script&lang=js"

import "./SubmitPopup.vue?vue&type=style&index=0&id=dec9abe0&scoped=true&lang=css"

import exportComponent from "/Users/curtismensah/Projects/Litt/Brit/brit-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dec9abe0"]])

export default __exports__